import { MaterialUICore } from '@iclinic/design-system';

const { makeStyles } = MaterialUICore;

export default makeStyles((theme) => ({
  drawerTitle: {
    padding: theme.spacing(4, 0, 0, 0),
  },
  mainBox: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    justifyContent: 'space-between',
    width: '384px',
  },
  dateTimeBox: {
    width: '100%',
    display: 'inline-flex',
    flexDirection: 'row',
  },
  dateBox: {
    marginRight: theme.spacing(4),
  },
  infoBox: {
    padding: theme.spacing(0, 4),
  },
  optionBox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.spacing(4),
  },
  fieldName: {
    marginTop: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  fieldValue: {
    marginTop: theme.spacing(1),
    color: theme.palette.text.primary,
  },
  longFieldValue: {
    color: theme.palette.text.primary,
    marginTop: theme.spacing(1),
    maxWidth: '320px',
    '& :first-letter': {
      textTransform: 'uppercase',
    },
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
    verticalAlign: 'middle',
  },
  backButton: {
    width: '94px',
    color: theme.palette.text.secondary,
    '& .MuiTypography-overline': {
      fontSize: '16px',
      letterSpacing: '0.44px',
      textTransform: 'none',
    },
    '& .MuiButton-startIcon': {
      color: theme.palette.grey[500],
    },
  },
  disabledButton: {
    color: theme.palette.text.secondary,
  },
}));
